import {alias, createModelSchema, primitive} from "serializr";
import {Schema} from "@/common/Schema";

import {BaseObject} from "@/common/BaseObject";
import {TriggerKind} from "@/modules/redactor/models/trigger/core/TriggerKind";
import {SearchModel} from "@/modules/redactor/models/search/SearchModel";

export class TriggerBase extends BaseObject {

    constructor(kind) {
        super();
        console.assert(kind);

        this._kind = kind;
        this._scope = null;
        this._delay = 0;
        this._amount = 1;
        this._visible = false;
        this._search = null;
        this._key = null;
    }

    get kind() {
        return this._kind;
    }

    get scope() {
        return this._scope;
    }

    set scope(value) {
        this._scope = value;
    }

    get delay() {
        return this._delay;
    }

    set delay(value) {
        this._delay = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get visible() {
        return this._visible;
    }

    set visible(value) {
        this._visible = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get search() {
        return this._search;
    }

    set search(value) {
        this._search = value;
    }

    valid() {
        if (this.search && !this.search.valid()) {
            return false;
        }

        if (Number.isNaN(this.delay) || this.delay < 0) {
            return false;
        }

        return this.kind && this.scope && this.amount >= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerBase());
        } else if (target instanceof TriggerBase) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerBase, {
    _uid: alias("uid", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _kind: alias("kind", TriggerKind.schema()),
    _delay: alias("delay", Schema.primitive()),
    _amount: alias("amount", Schema.primitive()),
    _search: alias("search", SearchModel.schema()),
    _visible: alias("visible", primitive()) /* don't change to Schema.primitive() */
});